export const init_mutation_observer = function(callback) {
    return new MutationObserver(callback);
}

const calc_point_tooltip_style = marker_pane_translate_3d_value => {
    const _get_combine_translate_3d_value = (translate3d_array) => {
        const { x, y } = translate3d_array.map(translate3d_value => {
            const regex_list = translate3d_value.match(/translate3d\((-??\d+(?:\.\d+)?)px, (-??\d+(?:\.\d+)?)px, 0px\)/)
            return  {
                x: +regex_list[1],
                y: +regex_list[2],
            }
        }).reduce((accumulator, regex_object) => {
            return {
                x: accumulator.x + regex_object.x,
                y: accumulator.y + regex_object.y
            }
        })
    
        return `translate3d(${x}px , ${y}px , 0px)`
    }
    
    const map_pane_translate_3d_value = document.querySelector('.leaflet-map-pane').style.transform
    const point_tooltip_translate3D_value = _get_combine_translate_3d_value([map_pane_translate_3d_value, marker_pane_translate_3d_value])
    return point_tooltip_translate3D_value
} 

export const calc_gis_tooltip_style = (point_selector) => {
    return calc_point_tooltip_style(document.querySelector(point_selector).parentElement.style.transform)
}

export const calc_focal_sign_tooltip_style = (point_selector) => {
    return calc_point_tooltip_style(document.querySelector(point_selector).style.transform)
}